import { useMemo } from "react";
import type { ReactNode } from "react";
import styles from "./Button.module.scss";
import MuiButton from "@mui/material/Button";
import type { ButtonProps as MuiButtonProps } from "@mui/material/Button";
import { combineClasses } from "@/lib/utils";

interface ButtonProps
  extends Omit<MuiButtonProps, "variant" | "children" | "className"> {
  outlined?: boolean;
  large?: boolean;
  // Swaps the brand primary color for $color-danger — for a destructive
  // action (decline, revoke, delete) that still needs the same button
  // chrome (filled or outlined) as everything else.
  danger?: boolean;
  className?: string | undefined;
  children: ReactNode;
}

const Button = ({
  outlined,
  large,
  danger,
  className = "",
  children,
  ...props
}: ButtonProps) => {
  const buttonClassName = useMemo(() => {
    return combineClasses(
      outlined ? styles.outlineButton : styles.primaryButton,
      large ? styles.largeButton : "",
      danger ? styles.dangerButton : "",
    );
  }, [outlined, large, danger]);

  return (
    <MuiButton
      {...props}
      variant={outlined ? "outlined" : "contained"}
      disableElevation
      className={combineClasses(styles.button, className, buttonClassName)}
    >
      {children}
    </MuiButton>
  );
};

export default Button;
